// ORDER-NOTES-3000 — mirrors backend/utils/order_notes_limit.py.
// Title Search products → 3,000 chars; Tax/MLS/Utility (and unknown) → 150.
export const TITLE_NOTES_MAX_LENGTH = 3000;
export const TAX_NOTES_MAX_LENGTH = 150;

export const LEGACY_TITLE_SEARCH_PRODUCTS = [
  'Current Owner Search', 'Two Owner Search', 'Full Search', 'AVR Search',
  'Deed Search', 'Mortgage Search', 'Legal and Vesting', 'O&E',
  'Commercial Full Search', 'Commercial COS',
];

export const isTitleNotesProduct = (clientProduct, workflowType = null) => {
  if (workflowType && String(workflowType).toUpperCase() === 'TITLE_SEARCH') return true;
  return LEGACY_TITLE_SEARCH_PRODUCTS.includes(clientProduct);
};

export const getNotesMaxLength = (clientProduct, workflowType = null) =>
  isTitleNotesProduct(clientProduct, workflowType) ? TITLE_NOTES_MAX_LENGTH : TAX_NOTES_MAX_LENGTH;

export const formatCount = (n) => Number(n || 0).toLocaleString('en-US');
